export default "__VITE_ASSET__CpMRBDKG__"